import { render, staticRenderFns } from "./CLAHE.vue?vue&type=template&id=7bd8d20e&scoped=true&"
import script from "./CLAHE.vue?vue&type=script&lang=ts&"
export * from "./CLAHE.vue?vue&type=script&lang=ts&"
import style0 from "./CLAHE.vue?vue&type=style&index=0&id=7bd8d20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8d20e",
  null
  
)

export default component.exports